/*
 * Module for moving a topic to a different folder from within the topic page
 */

define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicFolder/topicFolderView",
  "modules/shared/moveModal/moveModalModule",
], function ($, Marionette, Messenger, TopicFolderView, MoveModalModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicFolder";
      this.region = options.region;
    },
    show: function (topic, rootTopicGroup) {
      //if the topic parentGroupId is changed, re-show the module (need to attach the new topic folder model to the view)
      this.listenToOnce(
        topic,
        "change:parentGroupId",
        function () {
          this.show(topic, rootTopicGroup);
        },
        this,
      );

      //can only get the topic folder once the topic is synced
      topic.onSynced(function () {
        const topicFolder = topic.topicGroup();
        topicFolder.allowEditTopicFolder = Messenger.reqres.request("can:edit:topicFolder");
        const canArchiveTopic = Messenger.reqres.request("can:archive:topic");
        topicFolder.showArchiveTopicButton = canArchiveTopic && !topic.get("archived");
        topicFolder.showRestoreTopicButton = canArchiveTopic && topic.get("archived");
        this.view = new TopicFolderView.topicFolderView({ model: topicFolder });

        this.view.on(
          "move:topic",
          function () {
            Messenger.vent.trigger(
              "show:modal",
              MoveModalModule,
              {},
              {
                modelsToMove: [topic],
                rootGroup: rootTopicGroup,
                nameAttribute: "name",
                group: topicFolder,
              },
              {
                title: $.t("topic.move.title"),
                modalWidth: 400,
                trackInteraction: {
                  action: "Move Topic to Folder",
                  id: topic.id,
                  idType: "Topic",
                  object: "Topic",
                },
              },
            );
          },
          this,
        );

        this.showRegion(this.view);
      }, this);
    },
  });
});
